import Footer from "../components/Footer";
import Welcome from "../components/Welcome";
import BtWhatsapp from "../components/ButtonWhatsapp3";
import Scrolltop from "../components/Scrolltop";


export default function Welcomepage() {
  return (
    <>
      <main>
        <Welcome />
        <Footer />
      </main>
      <BtWhatsapp/>
      <Scrolltop />
    </>
  );
}
